var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSocks(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.103 19.543A3.785 3.785 0 006 22.225a3.77 3.77 0 001.087 2.655l.016.017A3.78 3.78 0 009.776 26c.974 0 1.94-.37 2.673-1.103l3.906-3.906a4.196 4.196 0 01-.974-2.7 4.21 4.21 0 011.24-2.99 4.24 4.24 0 012.596-1.217V5.007h-7.56v9.827a.401.401 0 01-.121.276l-4.43 4.43-.003.003zm10.06-3.69a3.44 3.44 0 00-1.008 2.44c0 .466.095.914.259 1.319.12.293.293.577.491.828l2.31-2.31v-3.267a3.43 3.43 0 00-2.052.99zm-5.508-11.62h7.56V2h-7.56v2.233z",
    fill: "#000",
    fillRule: "evenodd"
  })));
}

export default SvgSocks;